/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type HookTuple = [
  response: vp.VisaDirectPushTransactionResponse,
  fetchData: (transactionID: string) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchVisaDirectPushTransaction: ApiHook = ({ api }: HookProps) => {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<string>();
  const [response, setResponse] = useState<vp.VisaDirectPushTransactionResponse>({
    ErrorMessage: '',
    Success: false,
    TransactionID: '',
    TransactionStatus: vp.TransactionStatus.BLANK,
    TransactionDateTime: '',
    Amount: '',
    Currency: '',
    HoldAmount: '',
    CompanyName: '',
    FirstName: '',
    LastName: '',
    ClientReferenceNumber: '',
    KYCPerformed: '',
    KYCReferenceNumber: '',
    VisaTransferID: '',
    LastModified: '',
    MaskedCardNumber: '',
  });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: string) => {
      setDataFetchingInfo(true, 'processing', 'fullScreen', true);

      const res = await api.fetchVisaDirectPushTransaction({ TransactionID: requestParams }, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false, 'processing', 'fullScreen', false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams?: string) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse({
        ErrorMessage: '',
        Success: false,
        TransactionID: '',
        TransactionStatus: vp.TransactionStatus.BLANK,
        TransactionDateTime: '',
        Amount: '',
        Currency: '',
        HoldAmount: '',
        CompanyName: '',
        FirstName: '',
        LastName: '',
        ClientReferenceNumber: '',
        KYCPerformed: '',
        KYCReferenceNumber: '',
        VisaTransferID: '',
        LastModified: '',
        MaskedCardNumber: '',
      });
      setSendRequest(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchVisaDirectPushTransaction);
